import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagesService } from '../../../service/component_dependent/messages/messages.service';
import { StorageService } from '../../../service/managers/storage.service';
import { Messages } from '../../../model/messages';
import { Contacts } from '../../../model/contacts';
import { JsonManager } from '../../../service/managers/json-manager';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { MobKitService } from '../../../service/component_dependent/messages/mob-kit.service';
import { YonduService } from '../../../service/component_dependent/messages/yondu.service';

@Component({
  selector: 'app-messages-conversation',
  templateUrl: './messages-conversation.component.html',
  styleUrls: ['./messages-conversation.component.scss']
})
export class MessagesConversationComponent implements OnInit {

  protected messageContent: string;
  
  protected maxItemPerPage: number;
  protected page: number;
  protected lastPage: number;
  protected conversationID: number;
  protected contactID: number;

  protected currentThread = [];

  protected userMe;
  protected userOther;
  protected title;
  protected partner_id;

  private scrollBottomInit: boolean = true;
  private loading: boolean = false;
  private loadingr: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private messageService: MessagesService,
    private storageService: StorageService,
    private notifierService: NotifierService,
    private mobKitService: MobKitService,
    private yonduService: YonduService,
    private router: Router) {
  }

  ngOnInit() {
    this.initComponents();
  }

  protected onSend(message: Messages, conversationSelected: any) {

    message.contact_number_id = conversationSelected.contact_number.id;
    message.users_id = this.storageService.getUser().id;
    message.conversations_id = this.conversationID;
    message.content = this.messageContent;
    message.date_time_sent = JsonManager.getDateTime();
    message.status = 2;
    message.is_deleted = 0;
    message.is_incoming = 0;
    message.is_unread = 0;
  }

  protected onSendNumber() {
    var message: Messages;
    var conversationSelected: any;

    message = new Messages();
    message.send_type = 2;
   
    this.loading = true 

    
    
    conversationSelected = this.storageService.getContactSelected();
    const msg:any = {
       "conversations_id": conversationSelected['cv_id'],
       "contact_number_id" : conversationSelected['cn_id'],
       "content" : this.messageContent
    }

    this.messageService.sendMessage(msg).subscribe(
       (data:any) => {

         this.contactMessagesToBottom(data.new_msg);
         this.scrollBottomInit = true;
         this.messageContent = "";
         this.notifierService.showSuccess(data.message);
       },
       (err) => {
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(err.error.message));
        this.loading = false 
       },
       () => {
        this.loading = false 
       }
    )

       

      //this.contactMessagesToBottom(dataRecent.data.data[0]);
      //      this.scrollBottomInit = true;
        //    this.messageContent = "";
        //this.notifierService.showSuccess(dataMobKit.message);

    // this.onSend(message, conversationSelected);

    // this.messageService.createMessage(message).subscribe(
    //   (dataMessage: any) => {

    //     var mobKitMessage = {
    //       To: conversationSelected.contact_number.country_code + conversationSelected.contact_number.number,
    //       Message: message.content,
    //       id: dataMessage.data.id,
    //     }

    //     this.messageService.getRecentMessage(this.conversationID).subscribe(
    //       (dataRecent: any) => {
    //         this.contactMessagesToBottom(dataRecent.data.data[0]);
    //         this.scrollBottomInit = true;
    //         this.messageContent = "";
    //       }
    //     );

    //     this.mobKitService.sendMessage(mobKitMessage).subscribe(
    //       (dataMobKit: any) => {
    //         this.notifierService.showSuccess(dataMobKit.message);
    //         this.router.navigateByUrl("/joytogive/messages/all");
    //       }, (errorMobKit: any) => {
    //         console.log(errorMobKit);
    //       }
    //     );

    //   }, (errorMessage: any) => {
    //     this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(errorMessage.error.message));
    //   }

    // );

  }

  protected onSendWV() {
    var message: Messages;
    var conversationSelected: any;

    message = new Messages();
    message.send_type = 1;

    conversationSelected = this.storageService.getContactSelected();

    this.onSend(message, conversationSelected);

    this.messageService.createMessage(message).subscribe(
      (dataMessage: any) => {

        var mobKitMessage = {
          To: conversationSelected.contact_number.country_code + conversationSelected.contact_number.number,
          Message: message.content,
          id: dataMessage.data.id,
        }

        this.messageService.getRecentMessage(this.conversationID).subscribe(
          (dataRecent: any) => {
            this.contactMessagesToBottom(dataRecent.data.data[0]);
            this.scrollBottomInit = true;
            this.messageContent = "";
          }
        );

        this.yonduService.sendMessage(mobKitMessage).subscribe(
          (dataMobKit: any) => {
            this.notifierService.showSuccess(dataMobKit.message);
            this.router.navigateByUrl("/joytogive/messages/all");
          }, (errorMobKit: any) => {
            console.log(errorMobKit);
          }
        );

      }, (errorMessage: any) => {
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(errorMessage.error.message));
      }

    );
  }

  protected getMessages() {
    this.loadingr = true
    this.messageService.getMessages(this.conversationID, this.page, this.maxItemPerPage).subscribe(
      (data: any) => {
        this.concatMessagesToTop(data.data.data);
        this.lastPage = data.data.last_page;
        this.loadingr = false;
      },
      (err) => {
        this.page--;
        this.loadingr = false;
      },
      () => {
        this.loadingr = false;
      }
    )
  }
  
  protected scrollDownThread() {

    var thread: HTMLElement;

    if (this.scrollBottomInit) {
      thread = document.getElementById("thread");
      thread.scrollTop = thread.scrollHeight;

      this.scrollBottomInit = false;
    }

  }

  protected handleScroll() {
    var scroll;

    scroll = document.getElementById('thread');

    if (scroll.scrollTop == 0  && this.page <= this.lastPage) {
      
      this.page++;
      this.getMessages();
      scroll.scrollTop = 1;
    }
  }

  private initComponents() {
    this.title = this.storageService.getContactSelected().first_name + " " +
      this.storageService.getContactSelected().last_name + "<" +
      this.storageService.getContactSelected().country_code +
      this.storageService.getContactSelected().number + ">";
      this.partner_id = this.storageService.getContactSelected().partner_id
    
      
    this.userMe = this.storageService.getUser().first_name;
    this.userOther = this.storageService.getContactSelected().first_name;

    this.activatedRoute.params.subscribe(
      (data: any) => {
        this.conversationID = data.cv_id;
        this.contactID = data.c_id;
        this.maxItemPerPage = 6;
        this.page = 1;
        this.getMessages();
      }
    )
  }

  private concatMessagesToTop(data: any) {
    var tmp = [];

    for (let i = data.length - 1; i > -1; i--) {
      if (this.currentThread.length == 0) {
        tmp.push(data[i]);
      } else if (this.currentThread.length > 1 && (this.currentThread[0].id != data[i].id)) {
        tmp.push(data[i]);
      }
    }

    this.currentThread = tmp.concat(this.currentThread);
  }

  private contactMessagesToBottom(data: any) {
    this.currentThread = this.currentThread.concat(data);
  }

}
